import React, { useState, useEffect } from 'react';
import { FormGroup, Spinner, Form, Row, Col, Input, Button } from 'reactstrap';
import Select from 'react-select';
import { useForm } from 'react-hook-form';

//Api
import formulariovistoria_api from '../../../../api/formulariovistoria_api';
import contrato_api from '../../../../api/contrato_api';

//Helpers
import { showMessage } from 'helpers/message';


export default function ConfiguracaoFiscalizacao({ contrato, set_contrato, loadContrato }) {
    const { register, errors, handleSubmit, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

    //Estado de controle dos formularios
    const [formularios, set_formularios] = useState([]);

    //Estado de controle das opções dos formularios
    const [options_formularios, set_options_formularios] = useState([]);

    //Função de onChange do campo de formularios
    const handleChangeFormularios = (value) => {
        let _formularios = [];
        if (value)
            value.map(m => {
                _formularios.push(m.value);
            });
        set_formularios(_formularios);
    }

    //Estado de controle do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Função de envio dos dados dos formularios
    const onSubmit = (data) => {

        const json_submit = {
            ...data
        }
        json_submit.formularioVistorias_Ids = [...formularios];
        json_submit.contrato_Id = contrato.contrato_Id;
        console.log(json_submit)
        set_show_loading(true);
        contrato_api.configuracaoFiscalizacao(json_submit).then(response => {
            if (response.status !== 204) {
                showMessage("Aviso", response.message, 'error', null);
            }
            else {
                showMessage("Sucesso!", response.message, 'success', null);
                loadContrato();
            }
        }).finally(f => set_show_loading(false));

    }

    //Função de carregar os formularios
    const loadFormularios = () => {
        set_show_loading(true);
        formulariovistoria_api.getAll().then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
            }
            else {
                set_options_formularios(response.data.map(value => ({ value: value.formularioVistoria_Id, label: value.identificacao })));
            }
        }).finally(f => set_show_loading(false));
    }

    //Função que carrega os campos
    const setValues = () => {
        setValue("numeroMinimoVistorias", contrato.numeroMinimoVistorias);
        set_formularios(contrato.formularioVistoria_Ids);
        console.log(contrato)
    }
    useEffect(() => {
        loadFormularios();
        setValues();
    }, []);

    return (
        <div>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md="12" lg="12">
                        <FormGroup>
                            <label className="form-control-label">Lista de Formulários</label>
                            <Select
                                name="formularioVistorias_Ids"
                                options={options_formularios}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                onChange={(o) => handleChangeFormularios(o)}
                                value={options_formularios.filter((value) => formularios.filter(f => f == value.value).length > 0)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                isMulti={true}
                                ref={e => register(
                                    { name: "formularioVistorias_Ids" },
                                    { required: false })
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12" lg="4">
                        <FormGroup>
                            <label className="form-control-label">Número mínimo de vistorias no período</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="numeroMinimoVistorias"
                                innerRef={register({ required: true })}
                            />
                            {errors.numeroMinimoVistorias && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12" className="text-center">
                        <Button color="success" type="submit">
                            <i className="fas fa-save"></i>  Salvar
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}